import React from 'react'
import CustomSelect from '../../../components/Atoms/Select/CustomSelect'
import TransParentButton from '../../../components/Atoms/TransparentButton.js/TransParentButton'
import Button from '../../../components/Atoms/buttons/button'


const ActionModal = ({ isOpen, option = [], handleSubmit, modalName, toggleModal, selectedOption, error, handleOptionChange, message }) => {

    if (!isOpen) return null
    return (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/10 backdrop-blur-sm">
            <div className="bg-white p-6 rounded-[19px] shadow-lg text-center lg:w-[600px] w-11/12 mx-auto">
                <div className="flex items-center justify-center mb-4">
                    <img src="/warning.png" alt="" className="w-20 h-20" />
                </div>
                <p className="text-[17px] font-[600] text-black mb-4">{modalName}</p>
                <p className='capitalize'>{message}</p>
                <div className='flex justify-center items-center mx-auto p-2 pb-12'>
                    <CustomSelect
                        options={option}
                        value={selectedOption}
                        onChange={handleOptionChange}
                    />
                </div>

                {error && (
                    <p className="text-red-500 text-sm mt-2">{error}</p>
                )}

                <div className="flex justify-center gap-4">
                    <TransParentButton
                        onClick={toggleModal}>
                        Cancel
                    </TransParentButton>
                    <Button
                        onClick={handleSubmit}
                        disabled={!selectedOption}>
                        OK
                    </Button>
                </div>
            </div>
        </div>

    )
}

export default ActionModal